import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const API = process.env.REACT_APP_BACKEND_URL;
const resolveImg = (src) => (src && src.startsWith("http") ? src : `${API}${src}`);

/**
 * AdSlot renders active ads for a given placement.
 * placements: home-top | home-inline | sidebar | article-inline | footer
 */
export default function AdSlot({ placement, limit = 1, className = "" }) {
  const [ads, setAds] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get("/ads", { params: { placement, limit } })
      .then(r => { if (alive) setAds(r.data || []); })
      .catch(() => { if (alive) setAds([]); });
    return () => { alive = false; };
  }, [placement, limit]);

  if (ads.length === 0) return null;

  return (
    <div className={`ad-slot ${className}`} data-testid={`ad-slot-${placement}`}>
      {ads.map(ad => (
        <a
          key={ad.id}
          href={`${API}/api/ads/${ad.id}/click`}
          target={ad.open_in_new_tab !== false ? "_blank" : "_self"}
          rel="noreferrer sponsored"
          onClick={(e) => {
            // Use click endpoint but avoid double-track: intercept, hit tracker, then open link_url
            if (ad.link_url) {
              e.preventDefault();
              // Fire-and-forget tracker
              fetch(`${API}/api/ads/${ad.id}/click`).catch(() => {});
              if (ad.open_in_new_tab !== false) {
                window.open(ad.link_url, "_blank", "noopener,noreferrer");
              } else {
                window.location.href = ad.link_url;
              }
            }
          }}
          className="block group relative overflow-hidden rounded-2xl bg-slate-50 border border-slate-100"
          data-testid={`ad-${ad.id}`}
          title={ad.title}
        >
          <span className="absolute top-2 left-2 text-[9px] overline px-2 py-0.5 rounded-full bg-slate-900/70 text-white z-10">ad{ad.sponsor ? ` · ${ad.sponsor}` : ""}</span>
          {ad.image && (
            <img
              src={resolveImg(ad.image_mobile && window.innerWidth < 640 ? ad.image_mobile : ad.image)}
              alt={ad.title}
              className="w-full h-auto object-cover group-hover:scale-[1.02] transition-transform"
              loading="lazy"
            />
          )}
        </a>
      ))}
    </div>
  );
}
